import React from 'react';
import { motion } from 'framer-motion';
const menuData = [{
  category: 'Small Plates',
  items: [{
    name: 'Malaysian Chicken Satay',
    description: 'shallot, lime, cilantro, peanut sauce, sweet and spicy cucumber',
    price: '$23'
  }, {
    name: 'Thai Lettuce Wraps',
    description: 'minced chicken, shitake, water chestnut, savory sauce',
    price: '$23'
  }, {
    name: 'Shrimp Dumpling',
    description: 'steamed, sweet soy chili oil',
    price: '$19'
  }, {
    name: 'Malaysian Flatbread',
    description: 'flaky pastry, transitional Thai curry for dipping',
    price: '$27'
  }, {
    name: 'Salt and Pepper Shrimp',
    description: 'garlic, ginger, chili, 5 spice',
    price: '$28'
  }, {
    name: 'Thai Fried Tofu',
    description: 'savory Thai bean sauce',
    price: '$22'
  }, {
    name: 'Steamed BBQ Bun',
    description: 'sweet and savory pork, sweet soy',
    price: '$16'
  }]
}, {
  category: 'Soup and Salad',
  items: [{
    name: 'Thai Tom Yum Soup',
    description: 'lemongrass, shallot, kaffir, tomato',
    price: '$12',
    options: 'with Chicken $14 / Shrimp $16'
  }, {
    name: 'Egg Flower Soup',
    description: 'chicken broth, snow mushrooms, crispy shallot',
    price: '$12'
  }, {
    name: 'Seaweed Salad',
    description: 'rice vinegar, sesame oil',
    price: '$12'
  }, {
    name: 'Japanese Ginger Salad',
    description: 'mixed greens, cucumber, carrot, with Japanese ginger dressing',
    price: '$15',
    options: 'with ahi tuna $28'
  }]
}, {
  category: 'House Specialties',
  items: [{
    name: 'Fried Rice',
    description: 'mixed vegetables, red onion, bean sprout, pork belly',
    options: 'with Chicken $28 / Shrimp $32 / Barrel Cut Tips $35'
  }, {
    name: 'Stir-Fry Noodles',
    description: 'red cabbage, red onion, bean sprouts, scallions, egg noodles',
    options: 'with Chicken $28 / Shrimp $32 / Barrel Cut Tips $35'
  }, {
    name: 'Singapore Street Noodles',
    description: 'sugar snap peas, eggs, bean sprouts, rice noodles with Chicken and Shrimp',
    price: '$34'
  }, {
    name: 'Hong Kong Pan Fried Noodles',
    description: 'thin egg noodles, baby Bak Choy, water chestnut, shitake mushrooms, with diced chicken',
    price: '$34'
  }, {
    name: 'Malaysian Curry Noodles',
    description: 'red curry paste, coconut milk, bean sprouts, with Chicken and Shrimp',
    price: '$34'
  }, {
    name: 'Thai Curry',
    description: 'zucchini, squash, tomato, pineapple, basil, mint, peanut, jasmine rice',
    price: '$24',
    options: 'with Chicken $28 / Shrimp $32'
  }]
}, {
  category: 'Classics',
  note: 'All classics are served with steamed jasmine rice',
  items: [{
    name: 'Peking Roast Duck',
    description: 'blackberry glaze, seaweed salad',
    price: '$56'
  }, {
    name: 'Sweet and Sour Shrimp',
    description: 'green bell pepper, tomato, pineapple',
    price: '$32'
  }, {
    name: 'Kung Pao Chicken',
    description: 'water chestnuts, straw mushrooms, bamboo shoots, peanuts',
    price: '$30'
  }, {
    name: 'Pork Chop',
    description: 'grilled French-cut pork chop, shitake mushrooms, savory sauce',
    price: '$39'
  }, {
    name: 'Miso Salmon',
    description: 'sake, miso paste, stir-fry crispy shallots',
    price: '$52'
  }, {
    name: 'Steamed Sea Bass',
    description: 'ginger, garlic, soy, crispy shallots',
    price: '$58'
  }, {
    name: 'Seafood Curry',
    description: 'lobster, scallops, Tiger shrimp, bean sprouts, with savory curry soup',
    price: '$52'
  }]
}, {
  category: 'Sides',
  items: [{
    name: 'Wok-fried Snap Peas',
    description: 'with wasabi salt',
    price: '$12'
  }, {
    name: 'Baby Bok Choi',
    description: 'with garlic soy sauce',
    price: '$10'
  }, {
    name: 'Bean Sprouts',
    description: '',
    price: '$10'
  }, {
    name: 'Jasmine Rice',
    description: '',
    price: '$6'
  }]
}];
export function Menu() {
  return <div className="pt-32 md:pt-40 pb-24 bg-cream min-h-screen" data-id="element-254" data-mp="1xdcpe0zmhqrt">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-255" data-mp="21e6egxosxbma">
        <div className="text-center mb-16" data-id="element-256" data-mp="26boo6qan7uvc">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-257" data-mp="26chnx7b6pk3z">
            <h1 className="font-serif text-5xl md:text-6xl text-charcoal mb-4 uppercase tracking-widest" data-id="element-258" data-mp="3hsj02k0mdyx1">
              Freddie Cheah
            </h1>
            <div className="w-24 h-1 bg-warm-brown mx-auto mb-12" data-id="element-259" data-mp="3cwakx6mfa5pv"></div>
          </motion.div>
        </div>

        <div className="space-y-20" data-id="element-260" data-mp="dgxb0a44shhw">
          {menuData.map((section, sectionIndex) => <motion.section key={section.category} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: sectionIndex * 0.1
        }} data-id="element-261" data-mp="9fv73fz9rh9l" data-mpi={sectionIndex}>
              <div className="text-center mb-10" data-id="element-262" data-mp="1baoqghn85my9">
                <h2 className="font-serif text-3xl text-charcoal mb-2" data-id="element-263" data-mp="1g7yebsuytqjz">
                  {section.category}
                </h2>
                {section.note && <p className="text-gray-500 italic text-sm" data-id="element-264" data-mp="16hvkxrjxmal4">{section.note}</p>}
              </div>

              <div className="space-y-8" data-id="element-265" data-mp="shkw0u26n62l">
                {section.items.map((item, itemIndex) => <div key={itemIndex} className="flex flex-col" data-id="element-266" data-mp="xhqgnqa1bsb6" data-mpi={itemIndex}>
                    <div className="flex justify-between items-baseline" data-id="element-267" data-mp="xeuic0u9z1m7">
                      <h3 className="font-serif text-xl text-charcoal font-medium" data-id="element-268" data-mp="jj8uvy3owpvw">
                        {item.name}
                      </h3>
                      {item.price && <>
                          <div className="flex-grow border-b border-dotted border-gray-400 mx-4 relative top-[-6px] opacity-40" data-id="element-269" data-mp="2dtcmaum0y9rx"></div>
                          <span className="font-medium text-charcoal whitespace-nowrap" data-id="element-270" data-mp="6973nhf24z4d">
                            {item.price}
                          </span>
                        </>}
                    </div>

                    {item.description && <p className="text-gray-600 text-sm mt-1 leading-relaxed pr-12" data-id="element-271" data-mp="b8rybfn72lba">
                        — {item.description}
                      </p>}

                    {item.options && <p className="text-warm-brown text-sm mt-1 italic font-medium" data-id="element-272" data-mp="kzeat0zm6vpr">
                        {item.options}
                      </p>}
                  </div>)}
              </div>
            </motion.section>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-24 text-center text-xs text-gray-500 space-y-1 border-t border-gray-200 pt-8" data-id="element-273" data-mp="30ph9avp70l5f">
          <p className="italic" data-id="element-274" data-mp="2evs4mxtitsos">
            Please let your server know of peanut or any other allergies.
          </p>
          <p className="italic" data-id="element-275" data-mp="2jola5nwtd51x">Prices change without notice.</p>
          <p className="italic" data-id="element-276" data-mp="2om3hxaz3he8c">20% gratuity added to parties of 8 or more.</p>
          <p className="italic" data-id="element-277" data-mp="2oo7pq4046xdw">3% Added to Credit Card Sales only.</p>
        </motion.div>
      </div>
    </div>;
}